export const tableStyleOptions = "QPc";
export const headerRow = "RPc";
export const bandedRows = "SPc";
export const firstColumn = "TPc";
export const bandedColumns = "UPc";
export const tableControlMenuInsert = "VPc";
export const tableControlMenuInsertAbove = "WPc";
export const tableControlMenuInsertBelow = "XPc";
export const tableControlMenuInsertLeft = "YPc";
export const tableControlMenuInsertRight = "ZPc";
export const tableControlMenuDelete = "_Pc";
export const tableControlMenuDeleteTable = "$Pc";
export const tableControlMenuDeleteColumn = "aQc";
export const tableControlMenuDeleteRow = "bQc";
export const tableControlMenuMerge = "cQc";
export const tableControlMenuMergeAbove = "dQc";
export const tableControlMenuMergeBelow = "eQc";
export const tableControlMenuMergeLeft = "fQc";
export const tableControlMenuMergeRight = "gQc";
export const tableControlMenuSplit = "hQc";
export const tableControlMenuSplitHorizontally = "iQc";
export const tableControlMenuSplitVertically = "jQc";
export const tableControlMenuStyle = "kQc";
export const tableControlMenuStyleDefault = "lQc";
export const tableControlMenuStyleGrid = "mQc";
export const tableControlMenuStyleLightLines = "nQc";
export const tableControlMenuStyleTwoTones = "oQc";
export const tableControlMenuStyleLightBands = "pQc";
export const tableControlMenuStyleClear = "qQc";
export const tableControlMenuHeaderRow = "rQc";
export const tableControlMenuAlignCellVertically = "sQc";
export const tableControlMenuAlignCellHorizontally = "tQc";
export const tableControlMenuAlignCellLeft = "uQc";
export const tableControlMenuAlignCellCenter = "vQc";
export const tableControlMenuAlignCellRight = "wQc";
export const tableControlMenuAlignCellTop = "xQc";
export const tableControlMenuAlignCellMiddle = "yQc";
export const tableControlMenuAlignCellBottom = "zQc";
export const cellShading = "AQc";
export const predefinedTableStyles = "BQc";
export default {tableStyleOptions,headerRow,bandedRows,firstColumn,bandedColumns,tableControlMenuInsert,tableControlMenuInsertAbove,tableControlMenuInsertBelow,tableControlMenuInsertLeft,tableControlMenuInsertRight,tableControlMenuDelete,tableControlMenuDeleteTable,tableControlMenuDeleteColumn,tableControlMenuDeleteRow,tableControlMenuMerge,tableControlMenuMergeAbove,tableControlMenuMergeBelow,tableControlMenuMergeLeft,tableControlMenuMergeRight,tableControlMenuSplit,tableControlMenuSplitHorizontally,tableControlMenuSplitVertically,tableControlMenuStyle,tableControlMenuStyleDefault,tableControlMenuStyleGrid,tableControlMenuStyleLightLines,tableControlMenuStyleTwoTones,tableControlMenuStyleLightBands,tableControlMenuStyleClear,tableControlMenuHeaderRow,tableControlMenuAlignCellVertically,tableControlMenuAlignCellHorizontally,tableControlMenuAlignCellLeft,tableControlMenuAlignCellCenter,tableControlMenuAlignCellRight,tableControlMenuAlignCellTop,tableControlMenuAlignCellMiddle,tableControlMenuAlignCellBottom,cellShading,predefinedTableStyles};